import {
    VISITPROFILE_SUCCESS,
    VISITPROFILE_FAIL,
    SET_MESSAGE,
    VISITPROFILE_PENDING,
    ADD_VISITPROFILE_SUCCESS,
    ADD_VISITPROFILE_FAIL,
    ADD_VISITPROFILE_PENDING,
    UPDATE_VISITPROFILE_SUCCESS,
    UPDATE_VISITPROFILE_FAIL,
    UPDATE_VISITPROFILE_PENDING,
    VISITPROFILE_DETAIL_FAIL,
    VISITPROFILE_DETAIL_PENDING,
    VISITPROFILE_DETAIL_SUCCESS,
    VISITPROFILE_LIGHT_PENDING,
    VISITPROFILE_LIGHT_SUCCESS,
    VISITPROFILE_LIGHT_FAIL
} from "../../actions/types";

const initialState = {
    visitProfile: [],
    visitProfileDetail: [],
    addvisitProfile: '',
    updatevisitProfile: '',
    isVisitProfileLoading: false,
    visitProfileLight: {
        data: [],
        isLoading: false,
        error: null,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 20
    }
};

const visitProfile_reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case VISITPROFILE_SUCCESS:
            return {
                ...state,
                visitProfile: payload.visitProfile,
                isVisitProfileLoading: false,
            };
        case VISITPROFILE_PENDING:
            return {
                ...state,
                visitProfile: payload.visitProfile,
                isVisitProfileLoading: true,
            };
        case VISITPROFILE_FAIL:
            return {
                ...state,
                visitProfile: [],
                isVisitProfileLoading: false,
            };

        case VISITPROFILE_DETAIL_SUCCESS:
            return {
                ...state,
                visitProfileDetail: payload.visitProfileDetail,
            };
        case VISITPROFILE_DETAIL_PENDING:
            return {
                ...state,
                visitProfileDetail: payload.visitProfileDetail,
            };
        case VISITPROFILE_DETAIL_FAIL:
            return {
                ...state,
                visitProfileDetail: []
            };
        case ADD_VISITPROFILE_SUCCESS:
            return {
                ...state,
                addvisitProfile: payload.addvisitProfile,
            };
        case ADD_VISITPROFILE_PENDING:
            return {
                ...state,
                addvisitProfile: payload.addvisitProfile,
            };
        case ADD_VISITPROFILE_FAIL:
            return {
                ...state,
                addvisitProfile: false
            };
        case UPDATE_VISITPROFILE_SUCCESS:
            return {
                ...state,
                updatevisitProfile: payload.updatevisitProfile,
            };
        case UPDATE_VISITPROFILE_PENDING:
            return {
                ...state,
                updatevisitProfile: payload.updatevisitProfile,
            };
        case UPDATE_VISITPROFILE_FAIL:
            return {
                ...state,
                updatevisitProfile: false
            };
        case VISITPROFILE_LIGHT_PENDING:
            return {
                ...state,
                visitProfileLight: {
                    ...state.visitProfileLight,
                    isLoading: true,
                    error: null
                }
            };
        case VISITPROFILE_LIGHT_SUCCESS:
            return {
                ...state,
                visitProfileLight: {
                    data: payload.visitProfiles,
                    totalRecords: payload.totalRecords,
                    pageNumber: payload.pageNumber,
                    pageSize: payload.pageSize,
                    isLoading: false,
                    error: null
                }
            };
        case VISITPROFILE_LIGHT_FAIL:
            return {
                ...state,
                visitProfileLight: {
                    ...state.visitProfileLight,
                    isLoading: false,
                    error: payload.error
                }
            };
        default:
            return state;
    }
}
export default visitProfile_reducer